import posthog from 'posthog-js';
import { AppThunk, GetStateFunc } from '~/store/types/sharedTypes';
import { Dispatch } from 'redux';
import { StepStatus } from '~/enums';

interface EventBase {
  stepStatus?: StepStatus;
  actionName?: string;
}

export enum PostHogPageName {
  DASHBOARD = 'myqred_dashboard',
  PROFILE = 'myqred_profile',
}
export interface CapturePostHogEventProps extends EventBase {
  eventName: string;
  product: PostHogPageName;
}

export const capturePostHogEvent = ({
  eventName,
  product,
}: CapturePostHogEventProps): AppThunk => (
  _dispatch: Dispatch,
  getState: GetStateFunc
) => {
  const {
    client: { activeCompany, clientId },
    intl: { market },
  } = getState();

  const _eventName = `${product}_${eventName}`;

  const eventProperties = {
    market,
    webUserId: clientId,
    ...(activeCompany && { clientId: activeCompany.id }),
  };

  posthog.capture(_eventName, eventProperties);
};
